import React, { useEffect, useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import '../styles/auth-theme.css';

function BrandHeader(): React.JSX.Element {
  return (
    <div className="auth-brand">
      <div className="auth-wordmark">
        <span className="w-syn">Syn</span>
        <span className="w-phant">phant</span>
      </div>
    </div>
  );
}

export function LogoutPage(): React.JSX.Element {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    signOut().catch((err: unknown) => {
      setError((err as Error).message);
    });
  }, []);

  return (
    <div className="auth-page">
      <img className="auth-watermark" src="/synphant-badge.png" alt="" />
      <div className="auth-card">
        <BrandHeader />
        {error ? (
          <>
            <h1 className="auth-title">Sign Out Failed</h1>
            <p className="auth-error">{error}</p>
          </>
        ) : (
          <>
            <h1 className="auth-title">Signed Out</h1>
            <p className="auth-subtitle">You can close this tab.</p>
          </>
        )}
      </div>
    </div>
  );
}
